import React from 'react'
import {Helmet} from "react-helmet"
import he from 'he'

const MetaData = (props) => 
    <Helmet>
        <title>{he.decode(props.title) || 'Loading...'} | {he.decode(props.siteInfo.name) || 'TAQT Training en Advies'}</title>
        <meta name="description" content={props.meta.replace(/(<([^>]+)>)|\n/ig, "").replace(/&#(\d{0,4});/g, (fullStr, str) => String.fromCharCode(str) )} />
    </Helmet>

export default MetaData


// WEBPACK FOOTER //
// ./src/components/MetaData.js